import PhoneInputWithCountrySelect from 'react-phone-number-input/react-hook-form';
import styled from 'styled-components/macro';

export const FormPhoneInputStyled = styled(PhoneInputWithCountrySelect)`
  border: ${({ theme }): string => `${theme.borders.sm} ${theme.colors.primary.variant3}`};
  line-height: 22px;
  padding: 0.5rem 0.625rem;
  border-radius: ${({ theme }): string => theme.radius.sm};

  input {
    margin-left: 0.5rem;
    color: ${({ theme }): string => theme.colors.primary.variant11};
    font-size: ${({ theme }): string => theme.fontSize.xl};
    font-weight: ${({ theme }): number => theme.fontWeight.normal};
    font-family: ${({ theme }): string => theme.fontFamily.primary};
    border: none;
  }
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }): string => theme.colors.primary.variant9};
`;

export const RequiredSignStyled = styled.span`
  color: ${({ theme }): string => theme.colors.highlight.variant2};
`;
